import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { StripeService } from '../../../services/stripe.service';
import { UserService } from '../../../services/user.service';
import { ToastService } from '../../../services/toast.service';
import { AuthService } from '../../../services/auth.service';
import { StorageService } from '../../../services/storage.service';

@Component({
  selector: 'app-success',
  templateUrl: './success.component.html',
  styleUrl: './success.component.scss',

})
export class SuccessComponent implements OnInit {
  loading = true;
  successMessage: string | null = null;
  userId = ""; 

  constructor(private router: Router, 
    private route: ActivatedRoute, 
    private http: HttpClient,
    private stripeService: StripeService, 
    private userService: UserService, 
    private toaster: ToastService, 
    private authService: AuthService, 
    private storageService: StorageService
  ) {}

  ngOnInit() {
    this.fetchUserId()
    this.route.queryParams.subscribe((params) => {
      const sessionId = params['session_id'];
      if (sessionId) {
        this.confirmSubscription(sessionId);
      } else {
        this.loading = false;
        this.successMessage = 'No session ID found. Please try again.';
      }
    });
  }

  getSubscriptions() {
    this.stripeService.getUserSubscription().subscribe({
      next: (response) => {
        console.log("success.component.ts [fee334] getUserSubscription: ", response);
        this.storageService.setUserSubscription(response);
      },
      error: (error) => {
        console.error("Error fetching subscription ", error);
      }
    })
  }

  redirectTohome() {
    this.router.navigate(['/'], { replaceUrl: true });
  }

  fetchUserId(){
    this.userService.getCurrentUser().subscribe({
      next:(response) => {
        console.log("success.component.ts [fbdc58] fetchUserId: ", response);
        this.userId = response._id; 
      },
      error:(error) => {
        console.error("Error fetching userId", error); 
      }
    })
  }

 confirmSubscription(sessionId: string) {
  console.log("success.component.ts [d86819] userId: ", this.userId, "sessionId", sessionId);
  
  this.stripeService.confirmSubscription(this.userId, sessionId).subscribe(
    (response: any) => {
      this.loading = false;

      if (response.success) {
        this.successMessage = 'Subscription confirmed successfully!';
        
        // ✅ Clear trial cancelled banner flag
        localStorage.removeItem('showCancelledTrialBanner');

        this.getSubscriptions(); 

        // Optional: redirect to subscription dashboard
        this.router.navigate(['/'], { replaceUrl: true });
      } else {
        this.successMessage = 'Error confirming subscription: ' + response.error;
      }
    },
    (error) => {
      this.loading = false;
      console.error('Error confirming subscription:', error);
      this.successMessage = 'Error confirming subscription. Please try again.';
    }
  );
}
}
